export const productConstants = {
  PRODUCTSREMOTE_REQUEST: 'PRODUCTSREMOTE_GETALL_REQUEST',
  PRODUCTSREMOTE_SUCCESS: 'PRODUCTSREMOTE_GETALL_SUCCESS',
  PRODUCTSREMOTE_FAILURE: 'PRODUCTSREMOTE_GETALL_FAILURE',
}
